import ReactGA from "react-ga";

export default async (): Promise<RestaurantFromAPI[]> => {
  const t0 = performance.now();
  try {
    const response = await fetch(
      "https://us-central1-closingtime-1519505201251.cloudfunctions.net/getRestaurants",
      {
        headers: {
          origin: "https://closeti.me/"
        }
      }
    );
    const restaurants = await response.json();
    localStorage.setItem("restaurantList", JSON.stringify(restaurants));
    const t1 = performance.now();
    ReactGA.timing({
      category: "Mongo database",
      variable: "load",
      value: t1 - t0,
      label: "restaurants"
    });
    return restaurants;
  } catch (e) {
    if (process.env.NODE_ENV === "development") {
      return require("./restaurants.json");
    }
    return [];
  }
};
